import { useCallback } from 'react'
import { initialState } from '../components/fnaReducer'
import useContextData from './useContextData'

export default function useMetadata() {
  const { dispatch, state } = useContextData()
  const { metadata } = state ?? {}
  const initalstateMetadata = structuredClone(initialState.metadata)

  const setMetadata = useCallback(
    (newMetadata) => dispatch({ type: 'SET_METADATA', metadata: newMetadata }),
    [dispatch]
  )

  return [metadata, setMetadata, initalstateMetadata]
}
